import { generateClasses } from './generate-classes';

export const generateFabricClasses = <TClasses = unknown>(componentName: string, slots: string[]) => {
	return generateClasses<TClasses>('Fabric', componentName, slots);
};
